// DMC Wholesale - Bulk Orders page: automatic Weekly Ads run
// ----------------------------------------------------------
// Started by the Weekly Catalog tool, which opens the page like this:
//   /pages/bulk-orders?autorun=<collection-handle>&modes=25,none,50&expect=120
//
// It does exactly what you do by hand, once per ad type:
//   1. picks the collection (same as the collection dropdown)
//   2. Select All
//   3. sets the pricing option (25% profit, No pricing, 50% profit)
//   4. presses Weekly Ads (Run All), using the page's own runWeeklyAdsExport()
// The page keeps all its own rules (150 product limit, quality setting, ZIP option,
// file names, pricing and rounding). This file only presses the buttons in order.
//
// Without ?autorun= in the address this file does nothing at all.
(function () {
  var params = new URLSearchParams(window.location.search);
  var handle = (params.get('autorun') || '').trim().toLowerCase();
  if (!handle || !/^[a-z0-9][a-z0-9-]{0,200}$/.test(handle)) return;

  var wantedModes = (params.get('modes') || '25,none,50')
    .split(',')
    .map(function (m) { return m.trim().toLowerCase(); })
    .filter(Boolean);
  var expected = parseInt(params.get('expect') || '0', 10) || 0;
  var COUNTDOWN_SECONDS = 5;
  var MAX_LOAD_ATTEMPTS = 6;

  var bar = null;
  var textEl = null;
  var startBtn = null;
  var cancelBtn = null;
  var closeBtn = null;

  function sleep(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function waitFor(test, timeoutMs) {
    return new Promise(function (resolve) {
      var t0 = Date.now();
      (function poll() {
        var ok = false;
        try { ok = !!test(); } catch (e) { ok = false; }
        if (ok) return resolve(true);
        if (Date.now() - t0 > timeoutMs) return resolve(false);
        setTimeout(poll, 300);
      })();
    });
  }

  // ---------- the small status bar at the top of the page ----------
  function makeButton(label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.textContent = label;
    b.style.cssText = 'border:1px solid #C9A227;background:#C9A227;color:#1B2A4A;font-weight:700;padding:6px 14px;border-radius:5px;cursor:pointer;font-size:13px;';
    return b;
  }

  function makeBar() {
    bar = document.createElement('div');
    bar.id = 'dmc-autorun-bar';
    bar.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:10001;background:#1B2A4A;color:#fff;padding:12px 16px;font:14px/1.45 Arial,Helvetica,sans-serif;display:flex;gap:12px;align-items:center;justify-content:center;flex-wrap:wrap;box-shadow:0 2px 10px rgba(0,0,0,0.35);';
    textEl = document.createElement('span');
    textEl.style.cssText = 'text-align:center;';
    startBtn = makeButton('Start now');
    cancelBtn = makeButton('Cancel');
    cancelBtn.style.background = 'transparent';
    cancelBtn.style.color = '#fff';
    cancelBtn.style.borderColor = 'rgba(255,255,255,0.5)';
    closeBtn = makeButton('Close');
    closeBtn.onclick = function () { bar.style.display = 'none'; };
    startBtn.style.display = 'none';
    cancelBtn.style.display = 'none';
    closeBtn.style.display = 'none';
    bar.appendChild(textEl);
    bar.appendChild(startBtn);
    bar.appendChild(cancelBtn);
    bar.appendChild(closeBtn);
    document.body.appendChild(bar);
  }

  function say(message, tone) {
    textEl.textContent = message;
    bar.style.background = tone === 'error' ? '#8E2A1F' : tone === 'done' ? '#1F6B3A' : '#1B2A4A';
  }

  function finishWith(message, tone) {
    say(message, tone);
    startBtn.style.display = 'none';
    cancelBtn.style.display = 'none';
    closeBtn.style.display = '';
  }

  // ---------- helpers that press the page's own controls ----------
  function setMode(mode) {
    var sel = document.getElementById('pricing-select');
    if (sel) {
      sel.value = mode;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (typeof setPricingMode === 'function') setPricingMode(mode);
  }

  function collectionName() {
    var opt = document.querySelector('#collection-select option[value="' + handle + '"]');
    return opt ? opt.textContent.trim() : handle;
  }

  // Waits 5 seconds (so a wrong link can be cancelled), or until Start now is pressed.
  function countdown(name, packs) {
    return new Promise(function (resolve) {
      var left = COUNTDOWN_SECONDS;
      var finished = false;
      function end(go) {
        if (finished) return;
        finished = true;
        clearInterval(timer);
        startBtn.style.display = 'none';
        cancelBtn.style.display = 'none';
        resolve(go);
      }
      function show() {
        say('Weekly ads for "' + name + '" (' + packs + ' pack' + (packs === 1 ? '' : 's') + ') start in ' + left + '...');
      }
      startBtn.style.display = '';
      cancelBtn.style.display = '';
      startBtn.onclick = function () { end(true); };
      cancelBtn.onclick = function () { end(false); };
      show();
      var timer = setInterval(function () {
        left -= 1;
        if (left <= 0) end(true); else show();
      }, 1000);
    });
  }

  // Same as choosing the collection in the dropdown. Retries because a brand new or
  // just-published collection can take a few seconds to appear on the website.
  async function loadCollection() {
    var sel = document.getElementById('collection-select');
    if (sel && sel.querySelector('option[value="' + handle + '"]')) sel.value = handle;
    var rows = 0;
    for (var attempt = 1; attempt <= MAX_LOAD_ATTEMPTS; attempt++) {
      say('Loading the collection (try ' + attempt + ' of ' + MAX_LOAD_ATTEMPTS + ')...');
      await filterByCollection(handle);
      rows = document.querySelectorAll('#product-table-body .product-checkbox').length;
      if (rows > 0 && (!expected || rows >= expected)) break;
      if (attempt < MAX_LOAD_ATTEMPTS) await sleep(4000);
    }
    return rows;
  }

  async function main() {
    makeBar();
    say('Weekly ads: getting ready...');

    var ready = await waitFor(function () {
      return typeof runWeeklyAdsExport === 'function' &&
        typeof filterByCollection === 'function' &&
        typeof selectAllOnPage === 'function' &&
        typeof html2canvas !== 'undefined' &&
        window.jspdf && window.jspdf.jsPDF;
    }, 40000);
    if (!ready) {
      finishWith('The page tools did not finish loading. Reload this page to try again.', 'error');
      return;
    }

    var modes = wantedModes.filter(function (m) {
      return !!document.querySelector('#pricing-select option[value="' + m + '"]');
    });
    if (!modes.length) {
      finishWith('No valid ad types were asked for. Nothing was started.', 'error');
      return;
    }

    var go = await countdown(collectionName(), modes.length);
    if (!go) {
      finishWith('Cancelled. Nothing was started.', 'error');
      return;
    }

    var rows = await loadCollection();
    if (!rows) {
      finishWith('The collection "' + handle + '" shows no products on the website. Check that it is published to the Online Store, then reload this page.', 'error');
      return;
    }

    selectAllOnPage();
    var selected = typeof getSelectedIds === 'function' ? getSelectedIds().length : rows;
    if (selected > 150) {
      finishWith('The collection has ' + selected + ' products and the page allows 150 at a time. Nothing was started.', 'error');
      return;
    }

    var note = (expected && rows < expected)
      ? ' (' + rows + ' of ' + expected + ' products found; the rest may be out of stock or still syncing)'
      : '';

    var originalConfirm = window.confirm;
    var finished = [];
    try {
      // The page asks "Continue?" before each Weekly Ads run. The button was already pressed
      // on the Weekly Catalog tool, so that question is answered yes.
      window.confirm = function () { return true; };
      for (var i = 0; i < modes.length; i++) {
        setMode(modes[i]);
        var label = typeof catalogueLabel === 'function' ? catalogueLabel() : modes[i];
        say('Pack ' + (i + 1) + ' of ' + modes.length + ': ' + label + ' - ' + selected + ' products' + note + '. Keep this tab open.');
        var result = await runWeeklyAdsExport();
        if (result !== 'ok') {
          finishWith('Stopped during "' + label + '" (' + result + '). ' + (finished.length ? 'Finished before that: ' + finished.join(', ') + '.' : 'Nothing was finished.'), 'error');
          return;
        }
        finished.push(label);
        if (typeof closeProgress === 'function') closeProgress();
        await sleep(2000);
      }
    } finally {
      window.confirm = originalConfirm;
      setMode('25');
    }
    finishWith('Finished: ' + finished.join(' | ') + '. The files are in your Downloads folder.', 'done');
  }

  function boot() {
    main().catch(function (e) {
      if (!bar) makeBar();
      finishWith('Weekly ads stopped: ' + (e && e.message ? e.message : e), 'error');
    });
  }

  // Wait for the full page load so the page's own start-up code (which clears any old
  // selection) has already run before this file selects anything.
  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot);
})();